// extracted by mini-css-extract-plugin
export default {"backdrop":"loadingModal_backdrop__ss14Y","modal":"loadingModal_modal__1IO72","slide-down":"loadingModal_slide-down__o9ZdX"};